import { registerLocaleData } from '@angular/common';
import localeMs from '@angular/common/locales/ms';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

registerLocaleData(localeMs);

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
